import AppBar from '@material-ui/core/AppBar';
import Badge from '@material-ui/core/Badge';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
//------Material UI------//
import { makeStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import AccountCircle from '@material-ui/icons/AccountCircle';
import InfoIcon from '@material-ui/icons/Info';
import MoreIcon from '@material-ui/icons/MoreVert';
import NotificationsIcon from '@material-ui/icons/Notifications';
import Switch from '@material-ui/core/Switch';
import Tooltip from '@material-ui/core/Tooltip';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Brightness4Icon from '@material-ui/icons/Brightness4';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from 'react-query';
import { fetchApiData } from '../../../utils/service';
//import logoMobile from './logo/phishLogoForMobile.png';
import { NavLink } from 'reactstrap';
import basePCUrl from '../../../Globals';
import usePortalAuth from '../../../auth/usePortalAuth';
import useScript from '../CustomHooks/useScript';
import MSSPHeader from '../MSSP/MSSPHeader';
import LanguageDropdown from './LanguageDropdown';
import { appendLogoutTrace, clearLogoutTrace } from '../../../utils/logoutTrace';
import {
  collectPreferenceEntriesForLogout,
  restorePreferenceEntriesAfterLogout,
} from '../../../utils/userPreferences';
import ChangePasswordDialog from './ChangePasswordDialog';
import logo from './logo/phishLogo.png';
import darkModeLogo from './logo/phishCloudDarkModeLogo.png';
import './NavBar.css';


const NavBar = (props) => {
  //useScript('https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit');

  const { isAuthenticated, loginWithRedirect, logout, loading, getAccessTokenSilently } = usePortalAuth();

  let isNotLoading = props.isNotLoading;
  let translationData = props.translationData.data;

  //const alertBadgeNumber = props.alertAmount
  const [alertBadgeNumber, setAlertBadgeNumber] = useState();
  const toggleDarkMode = props.toggleDarkMode;
  const darkMode = props.darkMode;

  //const [preferredLanguage, setPreferredLanguage] = useState();
  //const [customerPortalUrl, setCustomerPortalUrl] = useState();

  //const toggleNavbar = () => setCollapsed(!collapsed);

  //-----AppBar State----//

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [infoAnchorEl, setInfoAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const [changePasswordOpen, setChangePasswordOpen] = React.useState(false);
  const isPasswordSession = (() => {
    try { return sessionStorage.getItem('pcAuthLoginMethod') === 'password'; } catch (_) { return false; }
  })();

  const isMenuOpen = Boolean(anchorEl);
  const isInfoMenuOpen = Boolean(infoAnchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const clientId = props.selectedClient;

  //const alertBadgeNumber = props.alertBadgeNumber
  //const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

  //Google Widget Logic
  // function googleTranslateElementInit() {
  //   window.google.translate.TranslateElement(
  //     { pageLanguage: 'en', includedLanguages: 'en,ja,de,es,fr,it,tr' },
  //     'google_translate_element'
  //   );

  //   var removePopup = document.getElementById('goog-gt-tt');
  //   removePopup.parentNode.removeChild(removePopup);
  //   $('.goog-logo-link').empty();
  //   $('.goog-te-gadget').html($('.goog-te-gadget').children());
  // }

  //const theme = useTheme();

  //--------AppBar styles------//
  const useStyles = makeStyles((theme) => ({
    navContainer: {
      //flexGrow: 1,
      //backgroundColor: '#fafafa',
      // backgroundColor: theme.palette.background.default,
      //height: '100%'
    },
    grow: {
      flexGrow: 1,
    },
    appBar: {
      // In dark mode use the elevated `paper` color (#1e1e1e) so the navbar has
      // a solid, distinguishable background against the darker page default
      // (#121212). Light mode keeps the existing `background.default`.
      backgroundColor: theme.palette.type === 'dark'
        ? theme.palette.background.paper
        : theme.palette.background.default,
      borderBottom: `1px solid ${theme.palette.divider}`,
      boxShadow: theme.palette.type === 'dark'
        ? '0 1px 3px rgba(0,0,0,0.6), 0 1px 2px rgba(0,0,0,0.4)'
        : '0 1px 3px rgba(0,0,0,0.05), 0 1px 2px rgba(0,0,0,0.04)',
      zIndex: 1100,
    },
    menuButton: {
      marginRight: theme.spacing(2),
      //backgroundColor: '#fafafa',
    },
    title: {
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
    },
    inputRoot: {
      color: 'inherit',
    },
    inputInput: {
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: '20ch',
      },
    },
    sectionDesktop: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'flex',
        alignItems: 'center',
        gap: 4,
      },
    },
    sectionMobile: {
      display: 'flex',
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    buttons: {
      padding: '8px 14px',
      fontFamily: 'Montserrat, sans-serif',
      borderRadius: 10,
      transition: 'background-color 0.2s ease',
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
      },
    },
    navLink: {
      textDecoration: 'none',
      color: theme.palette.text.primary,
      '&:hover': {
        color: theme.palette.text.primary,
      },
    },
    darkModeToggle: {
      marginLeft: 12,
      color: theme.palette.text.primary,
      '& .MuiSwitch-track': {
        backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.3) !important' : undefined,
      },
      '& .MuiIconButton-label': {
        color: 'inherit',
      },
    },
    navDivider: {
      width: 1,
      height: 28,
      backgroundColor: theme.palette.divider,
      margin: '0 8px',
    },
    menuPaper: {
      borderRadius: 10,
      boxShadow: '0 4px 16px rgba(0,0,0,0.10), 0 1px 4px rgba(0,0,0,0.06)',
    },
  }));

  const classes = useStyles();

  //-----AppBar Logic-----//

  const onLogOut = (props) => {
    props.setselectedClient([{ clientId: props.defaultClient, industry: '', name: 'No clients', numberOfUsers: 0 }]);
  };

  // NUCLEAR LOGOUT - Destroy everything but protect against DOM errors
  const handleLogout = async () => {
    console.log('🔥 NUCLEAR LOGOUT - DESTROYING ALL USER DATA 🔥');
    const logoutRunId = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    const toErrorMessage = (error) => {
      if (!error) {
        return 'unknown';
      }
      if (typeof error === 'string') {
        return error;
      }
      if (error.message) {
        return error.message;
      }
      try {
        return JSON.stringify(error);
      } catch (jsonError) {
        return String(error);
      }
    };
    const trace = (step, details = {}) => {
      appendLogoutTrace(step, { runId: logoutRunId, ...details });
    };
    clearLogoutTrace();
    
    try {
    
      // 1. PRESERVE USER-SCOPED UI PREFERENCE MAPS - SAVE BEFORE NUKE
      let preservedPreferenceEntries = [];
      try {
        preservedPreferenceEntries = collectPreferenceEntriesForLogout();
      } catch (storageError) {
        console.log('⚠️ Storage access error:', storageError);
      }
      
      // 2. NUCLEAR STORAGE DESTRUCTION
      try {
        localStorage.clear();
        console.log('💫 localStorage cleared');
      } catch (e) {
        console.log('⚠️ localStorage clear failed:', e);
      }
      
      try {
        sessionStorage.clear();
        console.log('💫 sessionStorage cleared');
      } catch (e) {
        console.log('⚠️ sessionStorage clear failed:', e);
      }
      trace('logout_storage_cleared');
      
      // 3. RESTORE USER-SCOPED UI PREFERENCE MAPS
      try {
        restorePreferenceEntriesAfterLogout(preservedPreferenceEntries);
        trace('logout_preferences_restored', {
          restoredPreferenceCount: preservedPreferenceEntries.length,
        });
      } catch (restoreError) {
        console.log('⚠️ Preferences restore failed:', restoreError);
        trace('logout_preferences_restore_failed', { error: toErrorMessage(restoreError) });
      }
    
    // 3.5. CLEAR PCAT EXTENSION UID — wipe the className so the browser extension
    // no longer sees the previous user's identity during the redirect window.
    try {
      const pcatElement = document.getElementById('PCAT');
      if (pcatElement) {
        pcatElement.className = '';
        console.log('🧹 Cleared PCAT extension uid');
      }
      trace('logout_pcat_cleared');
    } catch (pcatError) {
      console.log('⚠️ PCAT cleanup failed:', pcatError);
      trace('logout_pcat_clear_failed', { error: toErrorMessage(pcatError) });
    }

    // 4. KILL SPECIFIC USER DATA KEYS (redundant but ensures destruction)
    const userDataKeys = [
      'usid',
      'usid_expiry',
      'selected-client', 
      'portal-data-cache',
      'user-settings-cache',
      'AL',
      'training-progress',
      'user-config',
      'alertCount',
      'translationCache',
      'pcAuthTokens',
      'pcAuthUser',
      'pcAuthPendingStates',
      'pcAuthPendingState',
      'session_login_at',
    ];
    userDataKeys.forEach(key => {
      localStorage.removeItem(key);
      console.log(`🗑️ Killed localStorage key: ${key}`);
    });
    trace('logout_user_data_keys_removed', { removedKeyCount: userDataKeys.length });
    
      // 5. DESTROY ALL COOKIES (js-cookie and native)
      try {
        const cookieString = document.cookie || '';
        let cookieCount = 0;
        if (cookieString.trim()) {
          const allCookies = cookieString.split(';');
          cookieCount = allCookies.length;
          allCookies.forEach(cookie => {
            const trimmedCookie = cookie.trim();
            if (trimmedCookie) {
              const eqPos = trimmedCookie.indexOf('=');
              const name = eqPos > -1 ? trimmedCookie.substr(0, eqPos).trim() : trimmedCookie;
              if (name) {
                // Kill cookie in multiple ways to ensure destruction
                try {
                  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
                  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=.phishcloud.io`;
                  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=${window.location.hostname}`;
                  console.log(`🍪 Destroyed cookie: ${name}`);
                } catch (individualCookieError) {
                  console.log(`⚠️ Failed to destroy cookie ${name}:`, individualCookieError);
                }
              }
            }
          });
        } else {
          console.log('🍪 No cookies to destroy');
        }
        trace('logout_cookie_cleanup_complete', { cookieCount });
      } catch (cookieError) {
        console.log('⚠️ Cookie cleanup error:', cookieError);
        trace('logout_cookie_cleanup_failed', { error: toErrorMessage(cookieError) });
      }
    
      // 6. SAFE EXTERNAL DOM CLEANUP ONLY (never remove React-managed nodes like #PCAT)
      try {
        const reactRoot = document.getElementById('root');
        const externalSelectors = ['#pcatClientPortal'];
        let removedElements = 0;
        externalSelectors.forEach((selector) => {
          const elements = document.querySelectorAll(selector);
          elements.forEach((element) => {
            if (!element) {
              return;
            }
            const isInsideReactTree = !!reactRoot && reactRoot.contains(element);
            if (!isInsideReactTree) {
              element.remove();
              removedElements += 1;
              console.log(`🧹 Removed external element: ${selector}`);
            }
          });
        });
        trace('logout_external_dom_cleanup_complete', { removedElements });
      } catch (domError) {
        console.log('⚠️ External DOM cleanup failed, continuing logout:', domError);
        trace('logout_external_dom_cleanup_failed', { error: toErrorMessage(domError) });
      }
    
      // 7. NUCLEAR REACT QUERY CACHE ANNIHILATION
      try {
        if (props && props.queryClient) {
          console.log('💣 React Query cache cleanup...');
          try {
            await props.queryClient.cancelQueries();
          } catch (cancelError) {
            console.log('⚠️ Query cancellation failed, continuing:', cancelError);
            trace('logout_query_cancel_failed', { error: toErrorMessage(cancelError) });
          }
          props.queryClient.clear();
          console.log('✅ React Query cache cleanup complete');
          trace('logout_query_cache_cleared');
        } else {
          console.log('⚠️ No queryClient available for cleanup');
          trace('logout_query_client_missing');
        }
      } catch (queryError) {
        console.log('⚠️ React Query cleanup failed, continuing:', queryError);
        trace('logout_query_cleanup_failed', { error: toErrorMessage(queryError) });
      }
    
      // 8. RESET NON-DOM REACT STATE TO DEFAULT
      try {
        if (props && props.setSelectedClient) {
          console.log('🎯 Resetting selectedClient to 0');
          props.setSelectedClient(0);
        }
        // NOTE: Do not mutate PCAT/token React state during logout teardown.
        // We redirect immediately after cleanup; forcing React to unmount #PCAT
        // before navigation can race external DOM mutation and trigger removeChild errors.
        trace('logout_react_state_reset_complete');
      } catch (stateError) {
        console.log('⚠️ React state reset error:', stateError);
        trace('logout_react_state_reset_failed', { error: toErrorMessage(stateError) });
      }
    
    // 9. CLEAR ANY WEB API STORAGE
    try {
      if ('indexedDB' in window) {
        // Clear IndexedDB if used
        console.log('💾 Attempting IndexedDB cleanup...');
        trace('logout_indexeddb_cleanup_checked');
      }
    } catch (indexedDBError) {
      console.log('⚠️ IndexedDB cleanup failed:', indexedDBError);
      trace('logout_indexeddb_cleanup_failed', { error: toErrorMessage(indexedDBError) });
    }

    // 9.5 MARK THIS AS A LOGGED-OUT NAVIGATION
    try {
      const logoutMarker = JSON.stringify({ at: Date.now() });
      sessionStorage.setItem('pcPortalLoggedOut', logoutMarker);
      localStorage.setItem('pcPortalLoggedOut', logoutMarker);
      console.log('🏁 Set logout marker for login portal rendering');
      trace('logout_marker_written');
    } catch (logoutMarkerError) {
      console.log('⚠️ Failed to set logout marker:', logoutMarkerError);
      trace('logout_marker_write_failed', { error: toErrorMessage(logoutMarkerError) });
    }
    
    // 10. SMART LOGOUT - Force manual redirect for localhost
    const hostname = window.location.hostname;
    console.log(`🔐 Smart logout from: ${hostname}`);
    const forceRedirect = (targetUrl) => {
      if (window.location.href !== targetUrl) {
        trace('logout_force_redirect', { targetUrl });
        window.location.replace(targetUrl);
      } else {
        trace('logout_force_redirect_skipped_same_url', { targetUrl });
      }
    };
    
    if (hostname === 'localhost') {
      // LOCALHOST: Skip provider logout call and do manual redirect
      const localReturnUrl = `${window.location.origin}/PortalSignIn?loggedOut=1`;
      console.log(`📥 LOCAL DEV: Nuclear cleanup complete, redirecting to ${localReturnUrl}`);
      trace('logout_local_redirect_target', { targetUrl: localReturnUrl });
      forceRedirect(localReturnUrl);
    } else {
      // PRODUCTION/TEST: Use provider logout with proper returnTo
      let returnUrl;
      
      if (hostname === 'testportal.phishcloud.io') {
        returnUrl = 'https://testportal.phishcloud.io/PortalSignIn?loggedOut=1';
      } else {
        returnUrl = 'https://portal.phishcloud.io/PortalSignIn?loggedOut=1';
      }
      
      console.log(`🔄 PROVIDER LOGOUT: Redirecting to ${returnUrl}`);
      trace('logout_provider_redirect_target', { targetUrl: returnUrl });
      
      const logoutOptions = {
        returnTo: returnUrl,
        federated: true, // Clear provider session when supported
        localOnly: false,
        logoutParams: {
          returnTo: returnUrl,
          federated: true,
        },
      };
      try {
        // Some provider/network combinations never settle this promise.
        // Race with a timeout so logout cannot strand users on a spinner.
        trace('logout_provider_call_started', { timeoutMs: 1500 });
        await Promise.race([
          Promise.resolve(logout(logoutOptions)),
          new Promise((resolve) => setTimeout(resolve, 1500)),
        ]);
        trace('logout_provider_call_settled');
      } catch (logoutError) {
        console.log('⚠️ Provider logout error, falling back to manual redirect:', logoutError);
        trace('logout_provider_call_failed', { error: toErrorMessage(logoutError) });
      }

      console.log(`🚨 Final logout redirect to: ${returnUrl}`);
      trace('logout_provider_final_redirect', { targetUrl: returnUrl });
      forceRedirect(returnUrl);
    }
      
    } catch (masterError) {
      // Master try-catch: if ANYTHING fails, ensure logout still happens
      console.log('🚨 MASTER LOGOUT ERROR - FORCING EMERGENCY LOGOUT:', masterError);
      trace('logout_master_error', { error: toErrorMessage(masterError) });
      
      // Emergency fallback - just redirect to login
      try {
        const hostname = window.location.hostname;
        let emergencyUrl;
        
        if (hostname === 'localhost') {
          emergencyUrl = `${window.location.origin}/PortalSignIn?loggedOut=1`;
        } else if (hostname === 'testportal.phishcloud.io') {
          emergencyUrl = 'https://testportal.phishcloud.io/PortalSignIn?loggedOut=1';
        } else {
          emergencyUrl = 'https://portal.phishcloud.io/PortalSignIn?loggedOut=1';
        }
        
        console.log(`🔥 EMERGENCY LOGOUT REDIRECT: ${emergencyUrl}`);
        trace('logout_emergency_redirect', { targetUrl: emergencyUrl });
        window.location.href = emergencyUrl;
      } catch (emergencyError) {
        console.log('🚨 CRITICAL: Emergency logout failed:', emergencyError);
        trace('logout_emergency_redirect_failed', { error: toErrorMessage(emergencyError) });
        // Last resort - reload the page
        trace('logout_last_resort_reload');
        window.location.reload();
      }
    }
  };
  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleInfoMenuOpen = (event) => {
    setInfoAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleInfoMenuClose = () => {
    setInfoAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const openCustomerPortal = () => {
    getCustomerPortalLink().then(function (result) {
      if (result.status === 'Error') {
        window.open('https://portal.phishcloud.io/Dashboard/Error', 'newwindow', 'width=600,height=600');
      } else {
        window.open(result.url, 'newwindow', 'width=600,height=600');
      }
    });
  };

  const getAlertNumber = useQuery(
    ['alertCount'],
    async () => {
      if (props.accessLevel !== 'User') {
        const token = await getAccessTokenSilently();
        return fetchApiData(
          basePCUrl,
          token,
          'alertCount',
          props.accessLevel,
          clientId
        );
      }

      //   const token = await getAccessTokenSilently();
      //   setToken(token);
      //   return fetchApiData(basePCUrl, token, 'initialTranslator');
    }
    //  { enabled: isNotLoading, selectedClient }
  );

  let alertNumber = getAlertNumber?.data?.newAlertCount;

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      getContentAnchorEl={null}
      open={isMenuOpen}
      onClose={handleMenuClose}
      PaperProps={{ className: classes.menuPaper }}
      disableScrollLock
    >
      <MenuItem onClick={handleMenuClose}>
        <NavLink tag={Link} className={classes.navLink} to="/Dashboard/account-info"></NavLink>
      </MenuItem>
      {(props.accessLevel !== undefined && props.accessLevel === 'CompanyAdmin') ||
      props.accessLevel === 'AccountAdmin' ? (
        <MenuItem onClick={handleMenuClose}>
          <NavLink onClick={openCustomerPortal}>{props.getTranslation('billing', props.preferredLanguage)}</NavLink>
        </MenuItem>
      ) : null}
      {isPasswordSession && (
        <MenuItem
          onClick={() => {
            handleMenuClose();
            setChangePasswordOpen(true);
          }}
        >
          <span className={classes.navLink}>Change Password</span>
        </MenuItem>
      )}
      <MenuItem
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          handleMenuClose();
          handleLogout();
        }}
      >
        <span className={classes.navLink}>
          {props.getTranslation('log out', props.preferredLanguage)}
        </span>
      </MenuItem>
    </Menu>
  );

  const renderInfoMenu = (
    <Menu
      anchorEl={infoAnchorEl}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      getContentAnchorEl={null}
      open={isInfoMenuOpen}
      onClose={handleInfoMenuClose}
      PaperProps={{ className: classes.menuPaper }}
      disableScrollLock
    >
      <MenuItem onClick={handleInfoMenuClose}>
        <NavLink tag={Link} className={classes.navLink} to="/Dashboard/about-us">
          {props.getTranslation('about us', props.preferredLanguage)}
        </NavLink>
      </MenuItem>
      <MenuItem onClick={handleInfoMenuClose}>
        <NavLink tag={Link} className={classes.navLink} to="/Dashboard/contact-us">
          {props.getTranslation('contact', props.preferredLanguage)}
        </NavLink>
      </MenuItem>
      <MenuItem onClick={handleInfoMenuClose}>
        <NavLink tag={Link} className={classes.navLink} to="/Dashboard/Downloads">
          {props.getTranslation('downloads', props.preferredLanguage)}
        </NavLink>
      </MenuItem>
    </Menu>
  );

  const mobileMenuId = 'primary-search-account-menu-mobile';

  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      getContentAnchorEl={null}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
      PaperProps={{ className: classes.menuPaper }}
      disableScrollLock
    >
      <MenuItem>
        <IconButton aria-label="new alerts" color="inherit">
          <Badge badgeContent={alertNumber} color="secondary">
            <NotificationsIcon />
          </Badge>
        </IconButton>
        <p> {props.getTranslation('new alerts', props.preferredLanguage)}</p>
      </MenuItem>
      <MenuItem onClick={handleInfoMenuOpen}>
        <IconButton aria-label="new alerts" color="inherit">
          <InfoIcon />
        </IconButton>
        <p> {props.getTranslation('info', props.preferredLanguage)}</p>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>{props.getTranslation('profile', props.preferredLanguage)}</p>
      </MenuItem>
    </Menu>
  );

  //-----------Get Customer Portal Link------------//

  const getCustomerPortalLink = async () => {
    return new Promise(async (resolve, reject) => {
      const token = await getAccessTokenSilently();

      fetch(basePCUrl + 'StripeClient/GetCustomerPortalUrl', {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => {
          if (response.status !== 200) {
            console.log('Looks like there was a problem. Status Code: ' + response.status);
            return;
          }

          response.json().then((data) => {
            if (data.status === 'Error') {
              console.log(data.status);
              //setCustomerPortalUrl("https://portal.phishcloud.io/Dashboard/Error")
              resolve(data);
              //console.log(token)
            } else {
              //setCustomerPortalUrl(data.url);
              resolve(data);
            }
          });
        })
        .catch(function (err) {
          console.log('Fetch Error :-S', err);
        });
    });
  };

  function setCookie(cname, cvalue, exdays, cpath) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = 'expires=' + d.toUTCString();

    document.cookie = cname + '=' + cvalue + ';' + expires + ';' + cpath;
  }

  //Google Widget Logic
  // useEffect(() => {
  //   if (preferredLanguage !== undefined) {
  //     //let lowerCasePreferredLanguage = preferredLanguage.toLowerCase();
  //     if (lowerCasePreferredLanguage === 'jp') {
  //       setCookie('googtrans', '/en/' + 'ja', 1, 'path=/;');
  //     } else {
  //       setCookie('googtrans', '/en/' + lowerCasePreferredLanguage, 1, 'path=/;');
  //     }
  //     //googleTranslateElementInit();
  //   }
  // }, [preferredLanguage]);

  useEffect(() => {
    if (window.location.search.includes('error=')) {
      props.history.push('/Error');
    }
    const intervalCall = setInterval(() => {
      getAlertNumber.refetch();
    }, 60 * 1000);
    return () => {
      // clean up
      clearInterval(intervalCall);
    };
  }, [clientId]);

  // function getCookie(name) {
  //   function escape(s) {
  //     return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1');
  //   }
  //   var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
  //   return match ? match[1] : null;
  // }

  // useEffect(() => {
  //   if (languageLocalStorageChanged && !loading) {
  //     savePreferredLanguage(props.preferredLanguage);
  //     console.log(props.preferredLanguage);
  //   }
  // }, [languageLocalStorageChanged]);


  return (
    <React.Fragment>
      {isAuthenticated && (
        <React.Fragment>
          <Toolbar
            className={classes.appBar}
            style={{
              position: 'fixed',
              width: '100%',
              // Force a solid background. Inline styles win over any cascading
              // rules that may otherwise leave the navbar transparent in
              // dark mode.
              backgroundColor: darkMode ? '#1e1e1e' : '#fafafa',
              backdropFilter: 'none',
              opacity: 1,
            }}
          >
            <Typography className={classes.title} variant="h6" noWrap>
              {!darkMode ? (
                <img id="navbarLogo" src={logo} alt="Logo" />
              ) : (
                <img id="navbarLogo" src={darkModeLogo} alt="Logo" />
              )}
            </Typography>

            <div className={classes.grow} />
            <div className={classes.sectionDesktop}>
              <div id="google_translate_element"></div>
              {/* {!loadingUserSettings ?  */}

              <LanguageDropdown
                history={props.history}
                location={props.location}
                userSettings={props.userSettings}
                isNotLoading={isNotLoading}
                preferredLanguage={props.preferredLanguage}
                setPreferredLanguage={props.setPreferredLanguage}
              />

              <Tooltip title={props.getTranslation('Toggle Dark Mode', props.preferredLanguage)} placement="bottom">
                <FormControlLabel
                  id="label"
                  className={classes.darkModeToggle}
                  control={
                    <Switch
                      color="primary"
                      checked={darkMode}
                      onChange={() => {
                        toggleDarkMode(!darkMode);
                      }}
                    />
                  }
                  label={<Brightness4Icon />}
                  labelPlacement="end"
                />
              </Tooltip>
              <div className={classes.navDivider} />
              {props.accessLevel !== 'User' ? (
                <NavLink tag={Link} className={classes.navLink} to="/Dashboard/Alerts">
                  <IconButton aria-label="new alerts" className={classes.buttons}>
                    <Badge badgeContent={alertNumber} color="secondary" style={{ alignItems: 'center' }}>
                      <span id="alertsBadge">
                        {' '}
                        {alertNumber === 0 || alertNumber === undefined
                          ? props.getTranslation('no alerts', props.preferredLanguage)
                          : props.getTranslation('new alerts', props.preferredLanguage)}{' '}
                      </span>{' '}
                      <NotificationsIcon fontSize="large" />
                    </Badge>
                  </IconButton>
                </NavLink>
              ) : null}
              <IconButton
                edge="end"
                aria-label="account of current user"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={handleInfoMenuOpen}
                className={classes.buttons}
              >
                <InfoIcon fontSize="large" />
                <span id="alertsBadge">{props.getTranslation('info', props.preferredLanguage)} </span>
              </IconButton>
              <IconButton
                edge="end"
                aria-label="account of current user"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={handleProfileMenuOpen}
                className={classes.buttons}
              >
                <AccountCircle fontSize="large" />
                <span id="alertsBadge">{props.getTranslation('user', props.preferredLanguage)} </span>
              </IconButton>
            </div>
            <div className={classes.sectionMobile}>
              <IconButton
                aria-label="show more"
                aria-controls={mobileMenuId}
                aria-haspopup="true"
                onClick={handleMobileMenuOpen}
                className={classes.buttons}
              >
                <MoreIcon fontSize="large" />
              </IconButton>
            </div>
          </Toolbar>
          {/* REMOVED: MSSPHeader - redundant with Account Management menu
          {props.accessLevel != undefined && props.accessLevel === 'AccountAdmin' ? (
            <MSSPHeader
              selectedClient={props.selectedClient}
              defaultClient={props.defaultClient}
              accountAdminData={props.accountAdminData}
              getTranslation={props.getTranslation}
              preferredLanguage={props.preferredLanguage}
            />
          ) : null}
          */}
          {renderMobileMenu}
          {renderInfoMenu}
          {renderMenu}
          <ChangePasswordDialog
            open={changePasswordOpen}
            onClose={() => setChangePasswordOpen(false)}
            onLogout={handleLogout}
          />
        </React.Fragment>
      )}
      {!isAuthenticated && (
        <div className={classes.grow}>
          <AppBar className={classes.appBar}>
            <Toolbar>
              <div className={classes.grow} />
              <div className={classes.sectionDesktop}>
                <NavLink tag={Link} className="text-dark" to="/PortalSignIn">
                  <Button>{props.getTranslation('log in', props.preferredLanguage)} </Button>
                </NavLink>
              </div>
              <div className={classes.sectionMobile}>
                <NavLink tag={Link} className="text-dark" to="/PortalSignIn">
                  <Button>{props.getTranslation('log in', props.preferredLanguage)} </Button>
                </NavLink>
              </div>
            </Toolbar>
          </AppBar>
        </div>
      )}
    </React.Fragment>
  );
};
export default NavBar;

//"react-dom": "16.7.0-alpha.0",
